import { QueryClient } from '@tanstack/react-query';

export const setupQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: { retry: 2, refetchOnWindowFocus: false, throwOnError: false },
    },
  });
